module.exports = __webpack_public_path__ + "img/img-2.c1105310.jpg";